"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GenericRequestFormService = /** @class */ (function () {
    function GenericRequestFormService($q, $resource, toaster) {
        this.$q = $q;
        this.$resource = $resource;
        this.toaster = toaster;
        this.repository = $resource('/Partner/api/GenericRequest/Post');
    }
    GenericRequestFormService.prototype.postForm = function (model) {
        var _this = this;
        var promise = this.$q.defer();
        this.repository.save(model, function (result) {
            promise.resolve(result);
            _this.showSuccessToaster();
        }, function () {
            _this.showFailedToaster();
        });
        return promise;
    };
    GenericRequestFormService.prototype.showSuccessToaster = function () {
        this.toaster.pop('success', 'Submitted', 'Your request was successfully submitted.');
    };
    GenericRequestFormService.prototype.showFailedToaster = function () {
        this.toaster.pop('error', 'Submit failed', 'Error occurred during submit.');
    };
    return GenericRequestFormService;
}());
exports.GenericRequestFormService = GenericRequestFormService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZXJpY1JlcXVlc3RGb3JtLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJnZW5lcmljUmVxdWVzdEZvcm0uc2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBO0lBR0ksbUNBQ1ksRUFBcUIsRUFDckIsU0FBNEMsRUFDNUMsT0FBWTtRQUZaLE9BQUUsR0FBRixFQUFFLENBQW1CO1FBQ3JCLGNBQVMsR0FBVCxTQUFTLENBQW1DO1FBQzVDLFlBQU8sR0FBUCxPQUFPLENBQUs7UUFFcEIsSUFBSSxDQUFDLFVBQVUsR0FBRyxTQUFTLENBQUMsa0NBQWtDLENBQUMsQ0FBQztJQUNwRSxDQUFDO0lBRU0sNENBQVEsR0FBZixVQUFnQixLQUFzQjtRQUF0QyxpQkFXQztRQVZHLElBQUksT0FBTyxHQUFHLElBQUksQ0FBQyxFQUFFLENBQUMsS0FBSyxFQUFPLENBQUM7UUFFbkMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsS0FBSyxFQUFFLFVBQUMsTUFBVztZQUNwQyxPQUFPLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQ3hCLEtBQUksQ0FBQyxrQkFBa0IsRUFBRSxDQUFDO1FBQzlCLENBQUMsRUFBRTtZQUNDLEtBQUksQ0FBQyxpQkFBaUIsRUFBRSxDQUFDO1FBQzdCLENBQUMsQ0FBQyxDQUFDO1FBRUgsT0FBTyxPQUFPLENBQUM7SUFDbkIsQ0FBQztJQUVPLHNEQUFrQixHQUExQjtRQUNJLElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLFNBQVMsRUFBRSxXQUFXLEVBQUUsMENBQTBDLENBQUMsQ0FBQztJQUN6RixDQUFDO0lBRU8scURBQWlCLEdBQXpCO1FBQ0ksSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBTyxFQUFFLGVBQWUsRUFBRSwrQkFBK0IsQ0FBQyxDQUFDO0lBQ2hGLENBQUM7SUFDTCxnQ0FBQztBQUFELENBQUMsQUEvQkQsSUErQkM7QUEvQlksOERBQXlCIn0=